import { render, staticRenderFns } from "./PointNetridecashForm.vue?vue&type=template&id=c6997796"
import script from "./PointNetridecashForm.vue?vue&type=script&lang=js"
export * from "./PointNetridecashForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports